import type { RoleDto } from "common/models/api/models/RoleDto";
import ResourceInfo from "./ResourceInfo";

export type RoleMap = Record<string, RoleDto>;

export function getRoleMapKey(role: RoleDto): string {
    const resourceInfo = ResourceInfo.fromRole(role);
    return `${role.roleType}-${resourceInfo.name}`;
}
